import { authHeader, handleResponse } from './helper';
import config from '../config';
import { getCookie } from './cookies';

const listAdmissionPatient = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    }
  };
  const url = new URL(`${config.apiReservationUrl}/admissionPatients`);
  if (params) {
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  }
  return await fetch(url, requestOptions).then(handleResponse);
};

const admissionPatientPrestation = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };
  const url = new URL(`${config.apiReservationUrl}/admissionPatients/prestations/${params.admission_patient_id}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const deletePatient = async (params) => {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };
  const url = new URL(`${config.apiReservationUrl}/admissionPatients/${params.admission_patient_id}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const deletePatientExams = async (params) => {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };
  const url = new URL(`${config.apiReservationUrl}/admissionPatients/${params.admission_patient_id}/PatientExam/${params.type}/${params.type_id}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

const changeReservationNumber = async (urlParams, params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };
  const url = new URL(`${config.apiReservationUrl}/admissions/changeReservation/${urlParams.admission_patient_id}`);
  if (params) {
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  }
  return await fetch(url, requestOptions).then(handleResponse).catch((error) => error);
}

const getAdmissionPatientId = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };
  const url = new URL(`${config.apiGeneralUrl}/admissionPatients/getId`);
  if (params) {
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  }
  return await fetch(url, requestOptions).then(handleResponse);
};

const postEvaluationType = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiGeneralUrl}/admissionPatients/evaluationTypes`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const admissionPatientService = {
  listAdmissionPatient,
  admissionPatientPrestation,
  deletePatient,
  deletePatientExams,
  changeReservationNumber,
  getAdmissionPatientId,
  postEvaluationType,
};